import { Routes, Route, useNavigate } from 'react-router-dom';
import RouterList from './RouterList';
import { localGetStorage } from '@/lib/storage';
import { Fragment, useEffect } from 'react';
import { LOCAL_SESSION } from '@/lib/common/name-space';
import { toast } from 'react-toastify';
import { useWeb3 } from '@/hooks/use-web3';
import Layout from '@/layouts';
import { useWeb3AuthConnect, useWeb3AuthDisconnect } from '@web3auth/modal/react';

type routerProps = {
  path: string;
};
export default function Router({ path }: routerProps) {
  // '/' 두 개일 경우
  const length = path.split('/').length - 1;
  // 삼항?

  if (length > 2) {
    const temp = path.split('/');
    path = `/${temp[1]}/:path/:type`;
  } else if (length > 1) {
    const temp = path.split('/');
    path = `/${temp[1]}/:path`;
  }
  const list = RouterList();
  const routeList = list.filter((item) => path === item.url);
  if (routeList.length === 0) {
    return <></>;
    // TODO 완료 후 삭제
    // return <Navigate to="/signIn" />;
  }
  const route = routeList[0];

  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          {route.private === true ? (
            <>
              <Route path={route.url} element={<PrivateRoute element={route.element} url={route.url} />} />
            </>
          ) : (
            <Route path={route.url} element={route.element} />
          )}
        </Route>
      </Routes>
    </>
  );
}

type PrivateProps = {
  element: JSX.Element;
  url: string;
};
const PrivateRoute = ({ element, url }: PrivateProps) => {
  const { disconnect } = useWeb3AuthDisconnect();
  const { isConnected } = useWeb3AuthConnect();
  const navigate = useNavigate();
  const { clearWeb3Auth } = useWeb3();
  const session = localGetStorage(LOCAL_SESSION);
  const isSessionValid = session && new Date().getTime() <= session.sessionTime;

  useEffect(() => {
    if (!isSessionValid) {
      toast.error('세션이 만료되었거나 유효하지 않습니다.');
      localStorage.removeItem(LOCAL_SESSION);

      // Web3 연결이 되어있다면 연결 해제
      if (isConnected) {
        (async () => {
          await disconnect();
          clearWeb3Auth();
          // disconnect 후에 페이지 이동
          navigate('/pools');
        })();
      } else {
        // 연결이 안 되어있다면 바로 페이지 이동
        navigate('/pools');
      }
    }

    return () => {};
  }, [isConnected, disconnect, isSessionValid, navigate]);

  // 세션이 유효할 때만 자식 엘리먼트를 렌더링하고,
  // 유효하지 않다면 null을 반환하여 useEffect가 처리할 때까지 기다립니다.
  return isSessionValid ? element : null;
};
